export const summaryRows: string[] = [
  'Volume 1 — Fundamentals',
  'Volume 2 — Circuits & Analysis',
  'Volume 3 — Machines & Electromagnetic Systems',
  'Volume 4 — Power Generation, Transmission & Distribution',
  'Volume 5 — Installations, Protection & Control',
  'Volume 6 — Teaching Methods',
  'Bonus 1 — 150 Activities & Challenges',
  'Bonus 2 — Assessment Resource Pack',
  'Bonus 3 — 100 Case Studies',
  'Bonus 4 — 200 Essential Terms',
  'Bonus 5 — Lesson Planning Guide (14 Examples)',
  '7-day money-back guarantee',
  'Instant access',
];
